import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ShiftPlanListBubbleItemInterface, BaseInquiryShiftsWithFlexType } from 'base';

@Component({
  selector: 'base-customer-shift-plan-bubble',
  templateUrl: './base-customer-shift-plan-bubble.component.html',
})
export class BaseCustomerShiftPlanBubbleComponent {
  @Input() bubble: ShiftPlanListBubbleItemInterface;
  @Input() isVisible = true;
  @Input() isCalendar = false;
  @Output() bubbleClick = new EventEmitter<BaseInquiryShiftsWithFlexType>();

  bubbleClickHandler(selectedBubble: ShiftPlanListBubbleItemInterface) {
    this.bubbleClick.emit(selectedBubble.shift);
  }
}
